module.exports = __webpack_public_path__ + "img/1x1_collage.d34501d4.jpg";